// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23ffffff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddVideos_container__HF9fz {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 5rem !important;
  padding: 20px;
  background-color: #0a0a0a;
  color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.AddVideos_header__YyNAB {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #333;
  padding-bottom: 15px;
}

.AddVideos_headerIcon__ecAW4 {
  color: #ff1a1a;
  margin-right: 15px;
  font-size: 24px;
  width: 32px;
  height: 32px;
}

.AddVideos_header__YyNAB h1 {
  font-size: 24px;
  font-weight: 600;
  color: #ff1a1a;
  margin: 0;
}

.AddVideos_form__x\\+\\+VT {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AddVideos_formGroup__7B9aj {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.AddVideos_formGroup__7B9aj label {
  font-size: 16px;
  font-weight: 500;
  color: #cccccc;
}

.AddVideos_formGroup__7B9aj input,
.AddVideos_formGroup__7B9aj textarea,
.AddVideos_formGroup__7B9aj select {
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #333;
  background-color: #1e1e1e;
  color: #ffffff;
  font-size: 16px;
}

.AddVideos_formGroup__7B9aj input:focus,
.AddVideos_formGroup__7B9aj textarea:focus,
.AddVideos_formGroup__7B9aj select:focus {
  outline: none;
  border-color: #ff1a1a00;
  box-shadow: 0 0 0 2px rgba(255, 26, 26, 0.2);
}

.AddVideos_formGroup__7B9aj textarea {
  resize: vertical;
  min-height: 120px;
}

.AddVideos_select__xkhev {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

.AddVideos_imageUploadSection__Qt6h7 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.AddVideos_imageUpload__YzNik,
.AddVideos_videoUpload__OqPek {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.AddVideos_imageUpload__YzNik label,
.AddVideos_videoUpload__OqPek label {
  font-size: 16px;
  font-weight: 500;
  color: #cccccc;
}

.AddVideos_uploadArea__ItP\\+e {
  height: 180px;
  border: 2px dashed #333;
  border-radius: 8px;
  background-color: #121212;
  overflow: hidden;
}

.AddVideos_uploadPlaceholder__aCsS\\+ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 100%;
  cursor: pointer;
  position: relative;
}

.AddVideos_uploadPlaceholder__aCsS\\+:hover {
  background-color: #1a1a1a;
}

.AddVideos_uploadPlaceholder__aCsS\\+ svg {
  color: #ff1a1a;
  width: 32px;
  height: 32px;
}

.AddVideos_uploadPlaceholder__aCsS\\+ span {
  color: #cccccc;
  font-size: 14px;
}

.AddVideos_fileInput__5c04c {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.AddVideos_imagePreview__52yZj {
  position: relative;
  width: 100%;
  height: 100%;
}

.AddVideos_imagePreview__52yZj img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AddVideos_videoPreview__jXEYM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  height: 100%;
}

.AddVideos_videoPreview__jXEYM span {
  font-size: 14px;
  color: #cccccc;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.AddVideos_removeButton__IWDBM {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.AddVideos_videoPreview__jXEYM .AddVideos_removeButton__IWDBM {
  position: static;
  margin-left: 10px;
}

.AddVideos_removeButton__IWDBM:hover {
  background-color: rgba(255, 26, 26, 0.7);
}

.AddVideos_checkboxLabel__ReLff {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.AddVideos_checkboxLabel__ReLff input {
  width: 20px;
  height: 20px;
  accent-color: #ff1a1a;
}

.AddVideos_submitButton__CWZbt {
  background-color: #ff1a1a;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 20px;
}

.AddVideos_submitButton__CWZbt:hover {
  background-color: #e60000;
}

.AddVideos_submitButton__CWZbt:disabled {
  background-color: #666;
  cursor: not-allowed;
}

/* Responsive styles */
@media (max-width: 768px) {
  .AddVideos_container__HF9fz {
    padding: 15px;
  }
  
  .AddVideos_imageUploadSection__Qt6h7 {
    grid-template-columns: 1fr;
  }
  
  .AddVideos_header__YyNAB {
    margin-bottom: 20px;
  }
  
  .AddVideos_header__YyNAB h1 {
    font-size: 20px;
  }
  
  .AddVideos_formGroup__7B9aj label {
    font-size: 14px;
  }
  
  .AddVideos_formGroup__7B9aj input,
  .AddVideos_formGroup__7B9aj textarea,
  .AddVideos_formGroup__7B9aj select {
    padding: 10px;
    font-size: 14px;
  }
  
  .AddVideos_uploadPlaceholder__aCsS\\+ svg {
    width: 24px;
    height: 24px;
  }
  
  .AddVideos_uploadPlaceholder__aCsS\\+ span {
    font-size: 12px;
  }
  
  .AddVideos_submitButton__CWZbt {
    padding: 12px 16px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .AddVideos_container__HF9fz {
    padding: 10px;
  }
  
  .AddVideos_header__YyNAB {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .AddVideos_uploadArea__ItP\\+e {
    height: 150px;
  }
  
  .AddVideos_form__x\\+\\+VT {
    gap: 15px;
  }
}
/* Searchable Select Wrapper */
.AddVideos_searchableSelect__9K-\\+N {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.AddVideos_searchableSelect__9K-\\+N:hover {
  border-color: #ff3333;
}

.AddVideos_searchableSelect__9K-\\+N input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: #f0f0f0;
  font-size: 1rem;
  outline: none;
  width: 100%;
}

.AddVideos_searchableSelect__9K-\\+N .AddVideos_dropdownArrow__LFzhG {
  margin-left: 8px;
  font-size: 14px;
  color: #ff6666;
  transition: transform 0.2s ease;
}

.AddVideos_searchableSelect__9K-\\+N.AddVideos_open__5MRyc .AddVideos_dropdownArrow__LFzhG {
  transform: rotate(180deg);
}

/* Dropdown List */
.AddVideos_dropdownList__8MSPF {
 background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  margin-top: 5px;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: AddVideos_fadeIn__yUce6 0.2s ease-in-out;
}

.AddVideos_dropdownItem__Fv6bb {
  padding: 10px 14px;
  font-size: 1rem;
  color: #f0f0f0;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.AddVideos_dropdownItem__Fv6bb:hover {
  background-color: #ff3333;
  color: #ffffff;
}

.AddVideos_dropdownItem__Fv6bb:empty {
  color: #888888;
  text-align: center;
}

.AddVideos_dropdownList__8MSPF::-webkit-scrollbar {
  width: 6px;
}

.AddVideos_dropdownList__8MSPF::-webkit-scrollbar-thumb {
  background: #ff3333;
  border-radius: 4px;
}

.AddVideos_dropdownList__8MSPF::-webkit-scrollbar-track {
  background: #222222;
}

@keyframes AddVideos_fadeIn__yUce6 {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/Add Videos/AddVideos.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;AACA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,mDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-top: 5rem !important;\n  padding: 20px;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #333;\n  padding-bottom: 15px;\n}\n\n.headerIcon {\n  color: #ff1a1a;\n  margin-right: 15px;\n  font-size: 24px;\n  width: 32px;\n  height: 32px;\n}\n\n.header h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ff1a1a;\n  margin: 0;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.formGroup label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #cccccc;\n}\n\n.formGroup input,\n.formGroup textarea,\n.formGroup select {\n  padding: 12px;\n  border-radius: 5px;\n  border: 1px solid #333;\n  background-color: #1e1e1e;\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.formGroup input:focus,\n.formGroup textarea:focus,\n.formGroup select:focus {\n  outline: none;\n  border-color: #ff1a1a00;\n  box-shadow: 0 0 0 2px rgba(255, 26, 26, 0.2);\n}\n\n.formGroup textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.imageUploadSection {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.imageUpload,\n.videoUpload {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.imageUpload label,\n.videoUpload label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #cccccc;\n}\n\n.uploadArea {\n  height: 180px;\n  border: 2px dashed #333;\n  border-radius: 8px;\n  background-color: #121212;\n  overflow: hidden;\n}\n\n.uploadPlaceholder {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n}\n\n.uploadPlaceholder:hover {\n  background-color: #1a1a1a;\n}\n\n.uploadPlaceholder svg {\n  color: #ff1a1a;\n  width: 32px;\n  height: 32px;\n}\n\n.uploadPlaceholder span {\n  color: #cccccc;\n  font-size: 14px;\n}\n\n.fileInput {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.imagePreview {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.imagePreview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.videoPreview {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  height: 100%;\n}\n\n.videoPreview span {\n  font-size: 14px;\n  color: #cccccc;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.removeButton {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #ffffff;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.videoPreview .removeButton {\n  position: static;\n  margin-left: 10px;\n}\n\n.removeButton:hover {\n  background-color: rgba(255, 26, 26, 0.7);\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.checkboxLabel input {\n  width: 20px;\n  height: 20px;\n  accent-color: #ff1a1a;\n}\n\n.submitButton {\n  background-color: #ff1a1a;\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  padding: 14px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 20px;\n}\n\n.submitButton:hover {\n  background-color: #e60000;\n}\n\n.submitButton:disabled {\n  background-color: #666;\n  cursor: not-allowed;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .container {\n    padding: 15px;\n  }\n  \n  .imageUploadSection {\n    grid-template-columns: 1fr;\n  }\n  \n  .header {\n    margin-bottom: 20px;\n  }\n  \n  .header h1 {\n    font-size: 20px;\n  }\n  \n  .formGroup label {\n    font-size: 14px;\n  }\n  \n  .formGroup input,\n  .formGroup textarea,\n  .formGroup select {\n    padding: 10px;\n    font-size: 14px;\n  }\n  \n  .uploadPlaceholder svg {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .uploadPlaceholder span {\n    font-size: 12px;\n  }\n  \n  .submitButton {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 10px;\n  }\n  \n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .uploadArea {\n    height: 150px;\n  }\n  \n  .form {\n    gap: 15px;\n  }\n}\n/* Searchable Select Wrapper */\n.searchableSelect {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.searchableSelect:hover {\n  border-color: #ff3333;\n}\n\n.searchableSelect input {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  color: #f0f0f0;\n  font-size: 1rem;\n  outline: none;\n  width: 100%;\n}\n\n.searchableSelect .dropdownArrow {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #ff6666;\n  transition: transform 0.2s ease;\n}\n\n.searchableSelect.open .dropdownArrow {\n  transform: rotate(180deg);\n}\n\n/* Dropdown List */\n.dropdownList {\n background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  margin-top: 5px;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  font-size: 1rem;\n  color: #f0f0f0;\n  transition: background 0.2s ease, color 0.2s ease;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #ff3333;\n  color: #ffffff;\n}\n\n.dropdownItem:empty {\n  color: #888888;\n  text-align: center;\n}\n\n.dropdownList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdownList::-webkit-scrollbar-thumb {\n  background: #ff3333;\n  border-radius: 4px;\n}\n\n.dropdownList::-webkit-scrollbar-track {\n  background: #222222;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddVideos_container__HF9fz`,
	"header": `AddVideos_header__YyNAB`,
	"headerIcon": `AddVideos_headerIcon__ecAW4`,
	"form": `AddVideos_form__x++VT`,
	"formGroup": `AddVideos_formGroup__7B9aj`,
	"select": `AddVideos_select__xkhev`,
	"imageUploadSection": `AddVideos_imageUploadSection__Qt6h7`,
	"imageUpload": `AddVideos_imageUpload__YzNik`,
	"videoUpload": `AddVideos_videoUpload__OqPek`,
	"uploadArea": `AddVideos_uploadArea__ItP+e`,
	"uploadPlaceholder": `AddVideos_uploadPlaceholder__aCsS+`,
	"fileInput": `AddVideos_fileInput__5c04c`,
	"imagePreview": `AddVideos_imagePreview__52yZj`,
	"videoPreview": `AddVideos_videoPreview__jXEYM`,
	"removeButton": `AddVideos_removeButton__IWDBM`,
	"checkboxLabel": `AddVideos_checkboxLabel__ReLff`,
	"submitButton": `AddVideos_submitButton__CWZbt`,
	"searchableSelect": `AddVideos_searchableSelect__9K-+N`,
	"dropdownArrow": `AddVideos_dropdownArrow__LFzhG`,
	"open": `AddVideos_open__5MRyc`,
	"dropdownList": `AddVideos_dropdownList__8MSPF`,
	"fadeIn": `AddVideos_fadeIn__yUce6`,
	"dropdownItem": `AddVideos_dropdownItem__Fv6bb`
};
export default ___CSS_LOADER_EXPORT___;
